// external js: isotope.pkgd.js


// init Isotope

window.addEventListener('load', function(){

    var $grid = jQuery('.product-boards').isotope({
        itemSelector: '.product-board',
        transitionDuration: 0

    });
    
    jQuery('#product-board-filter').on( 'click', 'button', function() {

        var filterValue = jQuery( this ).attr('data-filter');

        jQuery('#product-board-filter button').removeClass('active');

        jQuery(this).addClass('active');
        

        jQuery('.product-board').removeClass('in-viewport');

        



        console.log(filterValue);

        $grid.isotope({ filter: filterValue });
        jQuery('.product-board').addClass('in-viewport');

    });


});